import { X } from 'lucide-react'

import styles from './ChipPreview.module.scss'

interface Props {
  label: string
  tag?: string
  onRemove?: () => void
  removeAriaLabel?: string
  /**
   * Optional FTUE anchor id. Forwarded to the root span so coachmarks
   * and flow-specific locks can target the chip without having to
   * thread React state through the composer.
   */
  ftueStep?: string
}

/**
 * Generic chip used by the composer chip bar. The visual matches the SDK
 * `AttachmentPreview` file pill exactly (rounded, light surface, hover-reveal
 * X) so files and the client tag read as one chip family.
 */
export function ChipPreview({ label, tag, onRemove, removeAriaLabel, ftueStep }: Props) {
  return (
    <span
      className={`${styles.chip}${onRemove ? '' : ` ${styles.readonly}`}`}
      title={label}
      data-ftue-step={ftueStep}
    >
      <span className={styles.label}>{label}</span>
      {tag ? <span className={styles.tag}>{tag}</span> : null}
      {onRemove ? (
        <button
          type="button"
          className={styles.removeButton}
          onClick={onRemove}
          aria-label={removeAriaLabel}
        >
          <X aria-hidden />
        </button>
      ) : null}
    </span>
  )
}
